import { createFileRoute } from "@tanstack/react-router"
import { AssetTypesView } from "src/views/AssetTypesView/AssetTypesView"
import { assetTypesViewStaticData } from "src/views/AssetTypesView/constants"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/asset-types/")({
	component: AssetTypesView,
	staticData: assetTypesViewStaticData,
})
